module.exports = __webpack_public_path__ + "img/success.2df32e09.svg";